<template>
  <el-dialog custom-class="medium-dialog" title="人员信息" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false"
  >
    <el-form :model="form" ref="form1" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" :label-width="formLabelWidth" prop="uname">
                <el-input v-model="form.uname" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号" :label-width="formLabelWidth" prop="mobile">
                <el-input v-model="form.mobile" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="所属部门" :label-width="formLabelWidth" prop="dname">
                <el-input v-model="form.dserial" auto-complete="off" :required="true" v-if="false"></el-input>
                <CommonTree ref="treeDserial" :isShowCheckBox="false" :treeHeight="200" :treeWidth="266"
                            :searchText="form.dname"
                            :onlyShowGroupType="true" @check="checktree1"></CommonTree>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="" :label-width="formLabelWidth" prop="status">
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="岗位" :label-width="formLabelWidth" prop="mainusernames">
                <el-input v-model="form.mainuserguids" auto-complete="off" :required="true" v-if="false"></el-input>
                <el-checkbox-group v-model="checkPost">
                  <el-checkbox v-for="(item,index) in postData" :key="item.uguid" :label="item.uguid">{{item.uname}}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
      <el-row :gutter="20" v-if="tenantlist.length>0">
        <el-col :span="24">
          <el-form-item label="授权门店" :label-width="formLabelWidth" prop="managetenant">
            <el-select v-model="managetenant" filterable multiple placeholder="请选择" style="width: 96%">
              <el-option
                v-for="item in tenantlist" :key="item.unitguid"  :label="item.tenantname" :value="item.unitguid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="userInfoModel.tenantid=='d6d0f500-6c34-45e6-b206-b87c368e4469'">
        <el-col :span="24">
          <el-form-item label="关联供应商" :label-width="formLabelWidth" prop="supplierserial">
            <el-select v-model="form.supplierserial" filterable  placeholder="请选择" style="width: 96%">
              <el-option
                v-for="item in supplys" :key="item.customerserial"  :label="item.deptname" :value="item.customerserial">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="入职日期" :label-width="formLabelWidth" prop="rzrq">
                <el-date-picker style="width:100%"
                                v-model="form.rzrq" :value-format="'yyyy-MM-dd'"
                                type="date"
                                placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别" :label-width="formLabelWidth" prop="sex">
                <el-radio-group v-model="form.sex">
                  <el-radio v-for="item in controlData.sex" :label="item.value" :key="item.value">{{item.text}}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

          </el-row>
     <el-row :gutter="20">
      <el-col :span="8">
      <el-form-item label="安全控制" :label-width="formLabelWidth" prop="enablemachinecodecheck">

     <el-radio label="1" v-model="form.enablemachinecodecheck">启用</el-radio>
    <el-radio label="0" v-model="form.enablemachinecodecheck">关闭</el-radio>

    </el-form-item>
    </el-col>
     <el-col :span="16">
      <el-form-item label="机器码" :label-width="formLabelWidth" prop="machinecode">
       <el-input v-model="form.machinecode" auto-complete="off" placeholder="多个用 ; 号隔开"  ></el-input>
     </el-form-item>
       <el-form-item label="WIFI" :label-width="formLabelWidth" prop="wifi">
         <el-input v-model="form.wifi" auto-complete="off" placeholder="多个用 ; 号隔开" ></el-input>
       </el-form-item>
   </el-col>
   </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="danger" @click="changData(5)" v-if="form.uguid&&form.status!=5&&form.uguid!=userInfoModel.uguid&&showremove" :disabled="isDisable">离 职</el-button>
      <el-button type="primary" @click="saveData" v-if="form.status!=5" :disabled="isDisable">保 存</el-button>
      <el-button type="warning" @click="changData(2)" v-if="form.uguid&&form.status==5" :disabled="isDisable">恢 复</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {getTableDate} from '@/api/set/post';
  import {saveData, getDetail, getControlData} from '@/api/set/employee';
  import {getListData as supplerList} from '@/api/set/externaldept';

  export default {
    name: "DataContactEdit",
    data() {
      return {
        isDisable: false,
        dialogFormVisible: false,
        activeNames: ['1', '2', '3', '4'],
        userInfoModel: {},
        postData: [],
        checkPost: [],
        managetenant: [],
        supplys: [],
        form: {  //表单数据
          uname: '',
          sfzh: '',
          sex: '0',
          gh: '',
          birsday: '',
          rzrq: '',
          byyx: '',
          xl: '',
          dserial: '',
          dname: '',
          mainuserguids: '',//岗位主职
          mainusernames: '',//岗位主职
          otheruserguids: '',//岗位副职
          otherusernames: '',//岗位副职
          managetenant: '',//分管的门店
          supplierserial: '',
          mobile: "",
          officetel: "",
          eMail: '',
          salarymode: 2,
          gdsalary: '',
          bankid: '',
          bankname: '',
          salarygroup: '',
          sbkh: '',
          gjjzh: '',
          gjjjs: '',
          paystyle: '1',
          uguid: '',
          status: 2,
          enablemachinecodecheck: "0",//机器码验证
          machinecode: '',//机器码
          wifi: '',
        },
        controlData: {//绑定的控件数据，例如下拉框、复选框，单选按钮组等。
          xl: [],
          salarymode: [],
          paystyle: [],
          salarygroup: [],
          sex: [],
          status: [],
          enabled: []
        },
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          uname: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
          ],
          mobile: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {pattern: /^0{0,1}(1[0-9][0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: '请输入正确的手机号', trigger: 'blur'},
          ],
        },
      }
    },
    methods: {
      changeStatus(data) {
      },
      getPost() {
        getTableDate({dserial: this.form.dserial}).then(response => {
          this.postData = response.data.obj;
        })
      },
      show(dserial, dname) {
        if (dserial) {
          this.form.dname = dname
          this.form.dserial = dserial
          this.getPost();
        }
        this.dialogFormVisible = true;

      },
      checktree1(guids, names, arr) {
        this.form.dserial = guids
        this.form.dname = names
        this.checkPost = []
        this.getPost();
      },
      checktreeMainUsers(guids, names, arr) {
        this.form.mainuserguids = guids
        this.form.mainusernames = names
      },
      checktreeOtherUsers(guids, names, arr) {
        this.form.otheruserguids = guids
        this.form.otherusernames = names
      },
      changData(status) {
        if (status == 5) {
          this.$confirm('是否确定离职?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.form.status = status;
            this.saveData();
          });
        }
        else {
          this.form.status = status;
          this.saveData();
        }
      },
      padZero(num) {
        if (num < 10) return '0' + num;
        return num;
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.isDisable = true;
            this.form.mainuserguids = this.checkPost ? this.checkPost.join(";") : '';
            this.form.managetenant = this.managetenant ? this.managetenant.join(";") : '';
            if (this.form.rzrq) {
              var rzrq = new Date(this.form.rzrq);
              this.form.rzrq = rzrq.getFullYear() + '-' + this.padZero(rzrq.getMonth() + 1) + '-' + this.padZero(rzrq.getDate());
            }
            this.form.otheruserguids = '';
            saveData(this.form).then(response => {
              if (response.data.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false;

                //刷新列表
                this.$emit('bindGrid');
              } else {
                this.$message.error(response.data.msg);
              }
              //
              this.isDisable = false;
            });
          }
        })
      },
      initData(uguid) {
        this.initForm()
        getDetail({uguid: uguid}).then(response => {
          for (let i in  this.form) {
            this.form[i] = response.data.obj[i];
          }
          this.checkPost = this.form.mainuserguids.split(';');
          this.managetenant = this.form.managetenant ? this.form.managetenant.split(';') : [];
          //this.getPost();
        })
      },
      initForm() {
        this.form.uname = ''
        this.form.sfzh = ''
        this.form.sex = '0'
        this.form.gh = ''
        this.form.birsday = ''
        this.form.rzrq = ''
        this.form.byyx = ''
        this.form.xl = ''
        this.form.dserial = ''
        this.postData = []
        this.checkPost = []
        this.form.dname = ''
        this.form.mainuserguids = ''//岗位主职
        this.form.mainusernames = ''//岗位主职
        this.form.otheruserguids = ''//岗位副职
        this.form.otherusernames = ''//岗位副职
        this.form.mobile = ""
        this.form.officetel = ""
        this.form.managetenant = ""
        this.managetenant = []
        this.form.supplierserial = "";
        this.form.eMail = ''
        this.form.salarymode = 2
        this.form.gdsalary = ''
        this.form.bankid = ''
        this.form.bankname = ''
        this.form.salarygroup = ''
        this.form.sbkh = ''
        this.form.gjjzh = ''
        this.form.gjjjs = ''
        this.form.paystyle = '1'
        this.form.uguid = ''
        this.form.status = 2
        this.form.enablemachinecodecheck = '0'
        this.form.machinecode = ''

      },
    },
    props: {
      showremove: {
        default: true
      },
      tenantlist: {
        default: []
      },
    },
    mounted() {
      supplerList({
        offset: 0,
        limit: 1000,
        unitgroup: 3,
        disabled: '',
      }).then(response => {
        this.supplys = response.data.obj.rows;
      });
      getControlData().then(response => {
        this.controlData = response.data.obj
        this.$emit("initControlData", this.controlData)
      })
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
    },
    components: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/set/employee/EmployeeEdit.vue